import { useEffect } from 'react'
import queryString from 'query-string'
import { useLocation, useNavigate } from 'react-router-dom'
import axios from 'providers/axios'
import useShowError from 'hooks/useShowError'
import AuthTemplate from 'components/templates/AuthTemplate'
import { LinearProgress } from '@mui/material'

const Logout: React.FC = () => {
  const showError = useShowError()
  const navigate = useNavigate()
  const location = useLocation()
  const parsed = queryString.parse(location.search)

  // set default mode (logout from app and home)
  useEffect(() => {
    if (parsed.mode) return
    parsed.mode = ['app', 'home']
    navigate({ search: queryString.stringify(parsed) })
  }, [navigate, parsed])

  // logout
  useEffect(() => {
    if (!parsed.mode) return
    const logout = async () => {
      try {
        const mode = parsed.mode
        await axios.post('/logout', {
          mode: Array.isArray(mode) ? mode : [mode],
        })
      } catch (error) {
        showError(error)
      } finally {
        delete parsed.mode
        navigate({
          pathname: '/login',
          search: queryString.stringify(parsed),
        })
      }
    }
    logout()
  }, [navigate, parsed, showError])

  return (
    <AuthTemplate>
      <h1 className="fs-18">Logging Out</h1>

      <LinearProgress sx={{ my: '40px', maxWidth: '400px', mx: 'auto' }} />
    </AuthTemplate>
  )
}

export default Logout
